import {LABEL} from "../../constants";
import React from "react";
import LogoRegulait, {ReactComponent as LogoRegulaitComp} from "../../../newShared/images/logo/regulait-logo.svg"
import LogoComplico, {ReactComponent as LogoComplicoComp} from "../../../newShared/images/logo/complico-logo.svg"

export const TobBarLogo = () => {
    switch (LABEL){
        case "Regulait": return <LogoRegulaitComp style={{margin: '0 16px'}}/>;
        case "Complico": return <LogoComplicoComp style={{margin: '0 16px'}}/>;
        default: return <LogoRegulaitComp style={{margin: '0 16px'}}/>;
    }
}

export const LoginLogo = ({onClick}:{onClick?:() => void}) => {
    switch (LABEL){
        case "Regulait": return <img src={LogoRegulait} alt={'Regulauit logo'} style={{maxHeight: '54px', maxWidth: '40%', cursor: 'pointer'}} onClick={onClick}/>;
        case "Complico": return <img src={LogoComplico} alt={'Regulauit logo'} style={{maxHeight: '54px', maxWidth: '40%', cursor: 'pointer'}} onClick={onClick}/>
        default: return <img src={LogoRegulait} alt={'Regulauit logo'} style={{maxHeight: '54px', maxWidth: '40%', cursor: 'pointer'}} onClick={onClick}/>;
    }
}